import { render, staticRenderFns } from "./ed-course-create-write-object.vue?vue&type=template&id=094057aa&scoped=true&"
import script from "./ed-course-create-write-object.ts?vue&type=script&lang=ts&"
export * from "./ed-course-create-write-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-create-write-object.scss?vue&type=style&index=0&id=094057aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094057aa",
  null
  
)

export default component.exports